import config from '../utils/ApiUrl';
import { getCookie, handleSessionExpire } from './session';

const API_URL = config.API_URL;

const fetchSupportMessages = async () => {
  const sessionToken = getCookie();
  if (!sessionToken) return handleSessionExpire();

  const response = await fetch(`${API_URL}/support-message`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${sessionToken}`,
    },
  });
  const data = await response.json();
  return data;
};

export { fetchSupportMessages };
